import * as Sentry from "@sentry/nextjs";
import {ROOT_LINK,
  CONTACT_SALES_PAGE_LINK,
  CONTACT_US_FROM_HEADER_PAGE_LINK,
  PRICING_PAGE_LINK, 
} from "constants/links";
import {isExactMatchToOneOfPages,truncateQueryParams} from "utils/url";

export const fireHotjarEventScript = (eventName) =>
  `(function(w){
        if(!hj) return;
        w.hj("event","${eventName}");
    })(window)`;

export const fireHotjarEvent = (eventName) => {
  try {
    if (window.hj) {
      window.hj("event", eventName);
    }
  } catch (e) {
    Sentry.captureException(e);
  }
};

// fires a list of events to Hotjar
export const fireHotjarEvents = (eventNames) => {
  // have only unique values
  const uniqueEventNames = eventNames.filter((element, index, array) => array.indexOf(element) === index);
  // fire each event, so filtering can be fully customized on Hotjar side
  uniqueEventNames.forEach((uniqueEventName) => fireHotjarEvent(uniqueEventName));
};

const ALLWAYS_RECORD_HOTJAR_URL_LIST = [
  ROOT_LINK,
  CONTACT_SALES_PAGE_LINK,
  CONTACT_US_FROM_HEADER_PAGE_LINK,
  PRICING_PAGE_LINK
];

const URL_TO_FREQUENCY = {
  [ROOT_LINK] : 500,
  [CONTACT_SALES_PAGE_LINK]: 25,
  [CONTACT_US_FROM_HEADER_PAGE_LINK]: 25,
  [PRICING_PAGE_LINK]: 100
};


export const allwaysRecordHotjar = (pageUrl) =>{
  return isExactMatchToOneOfPages(pageUrl, ALLWAYS_RECORD_HOTJAR_URL_LIST);
};

export const getRecordingFrequency = (hotjarRecordingFrequency, pageUrl) =>{
  if(isExactMatchToOneOfPages(pageUrl, ALLWAYS_RECORD_HOTJAR_URL_LIST)){
    const pathWithoutParams = truncateQueryParams(pageUrl);
    return URL_TO_FREQUENCY[pathWithoutParams];
  }
  return hotjarRecordingFrequency || 50;
};

export const currentSmallerThanFinalDate = (hotjarFinalDate) => {
  const currentDate = new Date();
  const finalDate = new Date(hotjarFinalDate);
  return ((currentDate).getTime()<=finalDate.getTime());
}


